var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Livello 1",
    id: "Livello_1",
    viewBox: "0 0 151.57 151.57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 1038.5,
    cy: 467.01,
    r: 72.28,
    style: {
      fill: "#da2244",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    transform: "translate(-988.78 479.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#da2244",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    x1: 47.57,
    x2: 103.99,
    y1: 103.99,
    y2: 47.57
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#da2244",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    x1: 45.8,
    x2: 105.7,
    y1: 45.87,
    y2: 105.77
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionFailed);
export default __webpack_public_path__ + "static/media/action_failed.1f69a3e5.svg";
export { ForwardRef as ReactComponent };